import { render, staticRenderFns } from "./RecognitionDecisionCell.vue?vue&type=template&id=0d75610f&scoped=true"
import script from "./RecognitionDecisionCell.vue?vue&type=script&lang=js"
export * from "./RecognitionDecisionCell.vue?vue&type=script&lang=js"
import style0 from "./RecognitionDecisionCell.vue?vue&type=style&index=0&id=0d75610f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75610f",
  null
  
)

export default component.exports